import React, { useState } from 'react'
import { Stack, Typography, Button, Box } from '@mui/material'

import CreditSelector from './CreditSelector'
import Wallet from './Wallet'
import { FragmentType, graphql, useFragment } from '@/generated/gql'
import useTenant from '@/hooks/useTenant'

const canteenCartTopUpContentUserDataFragment = graphql(`
  fragment CanteenCartTopUpContent_UserDataFragment on User {
    wallet {
      balance
    }
  }
`)

type Props = {
  loading: boolean
  onCheckoutClicked: (bundle: number) => void
  cartTotal: number
  userData: FragmentType<typeof canteenCartTopUpContentUserDataFragment>
  availableSubsidy: number
  currency: string
}

const Content: React.FC<Props> = ({
  loading,
  onCheckoutClicked,
  cartTotal,
  userData: userDataProp,
  availableSubsidy,
  currency,
}) => {
  const tenant = useTenant()
  const userData = useFragment(canteenCartTopUpContentUserDataFragment, userDataProp)
  const minimumTopupValue = tenant.features?.ccTopupAmounts?.minimumTopup ?? 0
  const totalToPay = cartTotal - availableSubsidy - userData.wallet.balance
  const [bundle, setBundle] = useState(totalToPay < minimumTopupValue ? minimumTopupValue : 0)

  const handleBundleChange = (newBundle: number) => {
    setBundle(newBundle)
  }

  const checkout = () => {
    onCheckoutClicked(bundle)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          position: 'relative',
          overflow: 'scroll',
        }}>
        <Stack spacing={5} paddingX={3} direction="column" height="100%">
          <Stack spacing={2} direction="column" alignItems="center">
            <Wallet />
            <Typography variant="subtitle2">Choose your amount</Typography>
            <Typography color="text.secondary" variant="subtitle3">
              Order faster next time by topping up
            </Typography>
          </Stack>
          <CreditSelector
            currency={currency}
            bundle={bundle}
            onChange={handleBundleChange}
            totalToPay={totalToPay}
          />
        </Stack>
      </Box>
      <Stack bgcolor="background.paper" paddingX={3} paddingY={2}>
        <Button
          variant="contained"
          size="medium"
          fullWidth
          onClick={checkout}
          disabled={loading || (totalToPay < minimumTopupValue && bundle === 0)}>
          Order now
        </Button>
      </Stack>
    </>
  )
}

export default Content
